import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const sauceBolognaise: Recipe = {
  slug: 'sauce-bolognaise',
  title: 'Sauce bolognaise',
  category: 'salé',
  description: 'Une sauce bolognaise mijotée au bœuf et à la chair à saucisse, aux carottes et aux échalotes.',
  image: image('sauce-bolognaise'),
  tags: ['bœuf', 'chair à saucisse', 'mijoté'],
  meta: [{ label: 'Cuisson', value: '1 h 30 à 2 h' }],
  sections: [
    section('Ingrédients', [
      ingredient('coulis', 'coulis de tomate', '1 L de coulis de tomate', {
        amount: 1,
        unit: 'L',
        shoppingKey: 'coulis de tomate',
      }),
      ingredient('vin', 'vin rouge', '40 cl de vin rouge', {
        amount: 40,
        unit: 'cl',
        shoppingKey: 'vin rouge',
      }),
      ingredient('boeuf', 'bœuf haché', '400 g de bœuf haché', {
        amount: 400,
        unit: 'g',
        shoppingKey: 'bœuf haché',
      }),
      ingredient('chair-a-saucisse', 'chair à saucisse', '400 g de chair à saucisse', {
        amount: 400,
        unit: 'g',
        shoppingKey: 'chair à saucisse',
      }),
      ingredient('carottes', 'carotte', '4 carottes', {
        amount: 4,
        unit: 'carotte',
        singularUnit: 'carotte',
        pluralUnit: 'carottes',
        shoppingKey: 'carotte',
        shoppingLabel: 'carottes',
      }),
      ingredient('echalotes', 'échalote', '4 échalotes', {
        amount: 4,
        unit: 'échalote',
        shoppingKey: 'échalote',
        shoppingLabel: 'échalotes',
      }),
      ingredient('matiere-grasse', 'beurre et huile d’olive', 'Beurre et huile d’olive, pour la cuisson', {
        shoppingKey: 'beurre et huile d’olive',
      }),
    ]),
  ],
  steps: [
    'Émincer très finement les échalotes et couper les carottes très finement.',
    'Faire revenir les échalotes et les carottes dans du beurre et de l’huile d’olive pendant une dizaine de minutes, puis déglacer avec du vin rouge. Mixer grossièrement avec un peu de coulis de tomate.',
    'Faire revenir le bœuf haché et la chair à saucisse dans du beurre et de l’huile d’olive, puis déglacer avec le reste du vin rouge. Laisser la viande sous forme de petites boulettes, sans la mixer.',
    'Tout mettre dans une casserole à fond épais et laisser épaissir pendant 1 h 30 à 2 h.',
  ],
}
